import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { captureException } from 'r/utils';
import { fetchApiRaw, GET_MARKETS_SCORE } from 'r/utils/fetchApiRaw';
import type { ScoreMarket } from 'r/types';

export const scoreMarketsFiltersAtom = atom({
  searchQuery: '',
  currentPage: 1,
  pageSize: 12,
});

export const scoreMarketsQueryAtom = atomWithQuery((get) => {
  const filters = get(scoreMarketsFiltersAtom);

  return {
    queryKey: [
      'score-markets',
      'list',
      filters.searchQuery.trim(),
      filters.currentPage,
      filters.pageSize,
    ],
    queryFn: async () => {
      try {
        const queryParams: Record<string, string> = {
          skip: String((filters.currentPage - 1) * filters.pageSize),
          take: String(filters.pageSize),
          sort: 'createdAt:desc',
        };

        if (filters.searchQuery.trim()) {
          queryParams.search = encodeURIComponent(filters.searchQuery.trim());
        }

        const response = await fetchApiRaw(GET_MARKETS_SCORE, {
          queryParams,
        });

        return {
          data:
            Array.isArray(response.data) ?
              (response.data as ScoreMarket[])
            : [],
          total: response.total || 0,
        };
      } catch (e) {
        captureException(e);
        return { data: [], total: 0 };
      }
    },
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  };
});
